<div class="date-input">
  <label *ngIf="label" class="text-default-label">
    {{ label }}
  </label>
  <div class="input-group">
    <input
      #dateInput
      type="date"
      class="form-control"
      [class.is-invalid]="validationError"
      [placeholder]="placeholder"
      [name]="name"
      [ngModel]="value"
      (ngModelChange)="onInput($event)"
      (blur)="onBlur()"
      (click)="openCalendar()"
      [disabled]="disabled"
      [min]="effectiveMin"
      [max]="effectiveMax"
    />
    <label
      class="input-group-text cursor-pointer"
      *ngIf="showIcon"
      (click)="openCalendar()"
      [for]="name"
    >
      <i class="mdi mdi-calendar-blank"></i>
    </label>
  </div>
  <div class="invalid-feedback d-block" *ngIf="validationError">
    {{ validationError }}
  </div>

  <div class="mt-2" *ngIf="showTime">
    <label *ngIf="timeLabel" class="text-default-label">
      {{ timeLabel }}
    </label>
    <input
      type="text"
      class="form-control"
      [class.is-invalid]="validationError"
      [placeholder]="timePlaceholder"
      [name]="timeName"
      [ngModel]="time"
      (ngModelChange)="onTimeInput($event)"
      [disabled]="timeDisabled"
      [mask]="'00:00'"
      [dropSpecialCharacters]="false"
    />
  </div>
</div>

